import React, { createContext, useContext, useEffect, useState } from 'react';
import { companyLogout, getCurrentCompany, primeCsrf, unifiedLogin } from '../api/auth';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await primeCsrf();
        const current = await getCurrentCompany();
        if (!cancelled) setCompany(current);
      } catch (err) {
        // Pas de session active — reste sur l'ecran de login.
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // Login UNIQUE : company / utilisateur de company OU superviseur. Renvoie le
  // role pour que LoginPage envoie chacun dans son espace.
  const login = async (username, password) => {
    const res = await unifiedLogin(username, password);
    setCompany(res.role === 'company' ? res.company : null);
    return res;
  };

  const logout = async () => {
    // Best-effort : si la session etait deja expiree/invalide cote serveur (ex.
    // double-clic sur "Deconnexion"), l'etat vise ("plus authentifie") est de
    // toute facon deja atteint — on ne bloque jamais la navigation pour ca.
    try {
      await companyLogout();
    } catch (err) {
      // ignore
    }
    setCompany(null);
  };

  return (
    <AuthContext.Provider value={{ company, loading, login, logout, setCompany }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within an AuthProvider');
  return ctx;
};
